import { ConfigProvider } from "antd";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AxiosHelper } from "./helpers/Axios.Helper";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

AxiosHelper.addCommonAxiosHeaders();

ReactDOM.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: "#fed136",
        fontSize: "1rem",
      },
    }}
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ConfigProvider>,
  document.getElementById("react-root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
